import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import PasswordTextField from './PasswordTextField'
import AuthCenterClient from 'auth-center-js-client'
import { TextFieldType } from 'foundations-library/types'
import PasswordStrengthBars from './PasswordStrengthBars'
import { Icon, Typography } from 'foundations-library/components'

const client = new AuthCenterClient()

const newPasswordHelperText = 'Please add all necessary characters to create a safe password'
const newPasswordValidationError = () => {
    return <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        <Icon name='notification-alert' size={16} color='destructive-500' />
        <Typography variant='body4' color='destructive-500'>Please add all necessary characters to create a safe password</Typography>
    </div>
}

const jss = (t) => {
    const { typography, colors } = t['foundations-library']
    return {
        validationContainer: {
            marginBottom: '20px',
            marginTop: '15px'
        },
        passwordStrengthBars: {
            marginBottom: '15px'
        },
        list: {
            paddingLeft: '20px'
        },
        ruleText: {
            ...typography.body3,
            '&.list-item-not-completed::marker': {
                color: colors.destructive[500]
            }
        }
    }
}

const useStyles = makeStyles(jss)

/**
 *
 */
const NewPasswordTextField = (props: TextFieldType & { mode?: 'update' | 'create' }): JSX.Element => {
    const styles = useStyles()
    const [newPasswordFieldHasBeenChanged, setNewPasswordFieldHasBeenChanged] = useState(false)
    const [validationResults, setValidationResults] = useState({})

    useEffect(() => {
        if (!newPasswordFieldHasBeenChanged && props.value) {
            setNewPasswordFieldHasBeenChanged(true)
        }
        client.checkNewUserPassword({ password: props.value, localChecksOnly: true })
            .then((rulesResponse) => {
                setValidationResults(rulesResponse)
            })
    }, [props.value])

    useEffect(() => {
        props.isValid && props.isValid(!!validationResults.checkPassed)
    }, [validationResults?.checkPassed])

    return <div>
        <PasswordTextField
            label={props.mode === 'create' ? 'Create Password' : 'New Password'}
            name="password"
            autoComplete='new-password'
            helperText={validationResults.checkPassed ? newPasswordHelperText : newPasswordValidationError()}
            data-testid='new-password'
            {...props}
        />
        {
            validationResults.checkStatus?.length && <div className={styles.validationContainer}>
                <PasswordStrengthBars
                    total={validationResults.summary.passCount + validationResults.summary.failCount}
                    completed={
                        !newPasswordFieldHasBeenChanged && !props.value ? 0 : validationResults.summary?.passCount
                    }
                    className={styles.passwordStrengthBars}
                />
                <div>
                    <ul className={styles.list}>
                        {validationResults.checkStatus.map((rule) => {
                            return <li
                                className={`${styles.ruleText} ${newPasswordFieldHasBeenChanged &&
                                    !rule.passed &&
                                    newPasswordFieldHasBeenChanged &&
                                    'list-item-not-completed'
                                }`}
                                key={rule.id}
                                data-testid={`rule-${rule.id}`}
                            >
                                <Typography
                                    variant='body3'
                                    color={
                                        (rule.passed || !newPasswordFieldHasBeenChanged) ? 'neutral-900' : 'destructive-500'
                                    }
                                >{rule.description}</Typography>
                            </li>
                        })}
                    </ul>
                </div>
            </div>
        }
    </div>
}

export default NewPasswordTextField
